/**
 * Scroll Animations Engine
 * Uses IntersectionObserver to trigger animations when elements enter the viewport.
 */
document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.05
  };

  const scrollObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-animated');
        // Stop observing once animated
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // 1. Observe all Shopify Sections for Homepage scroll reveal
  // We exclude header, footer, and sections that might be hidden or modal-based
  const excludedSections = ['header-section', 'footer-section', 'predictive-search', 'quick-order-list'];
  // Sections inside these containers, or containing fixed-position overlays, must never be
  // transformed: a transform on an ancestor breaks `position: fixed` (popup ends up hidden at
  // the bottom of the page while still locking scroll).
  const excludedContainers = '#header-group';
  const fixedOverlaySelectors = '.selecfit-promo-popup, .promotional-bar-section';
  document.querySelectorAll('.shopify-section').forEach(section => {
    let shouldExclude = false;
    excludedSections.forEach(className => {
      if (section.classList.contains(className)) shouldExclude = true;
    });
    if (section.closest(excludedContainers) || section.querySelector(fixedOverlaySelectors)) {
      shouldExclude = true;
    }

    if (!shouldExclude) {
      section.classList.add('scroll-animate-section');
      scrollObserver.observe(section);
    }
  });

  // 2. Observe specific items for staggered product entrance
  document.querySelectorAll('.scroll-animate-item').forEach(item => {
    scrollObserver.observe(item);
  });
});
